import {
  CUSTOMER_PRICES_RECEIVE_PRICES,
  CUSTOMER_PRICES_ARTICLE_NUMBER_TO_FETCH_PRICES,
  CUSTOMER_PRICES_SHOULD_FETCH_PRICES,
} from '../Actions/CustomerPrices.action';

const defaultState = {
  payload: {},
  priceList: [],
  articleNumberToFetchPrices: [],
};

export const customerPrices = (state = defaultState, action) => {
  const { payload } = action;
  switch (action.type) {
    case CUSTOMER_PRICES_RECEIVE_PRICES:
      return {
        ...state,
        priceList: [...state.priceList, ...payload.priceList],
      };
    case CUSTOMER_PRICES_ARTICLE_NUMBER_TO_FETCH_PRICES: {  
      if (!state.articleNumberToFetchPrices.includes(payload.articleNumber)) {
        return {
          ...state,
          articleNumberToFetchPrices: [
            ...state.articleNumberToFetchPrices,
            payload.articleNumber,
          ],
        };
      }
      return state;
    }
    default:
      return state;
  }
};
